export const initialMemosState = {
    memo: {
        id: null,
        memo_text: null,
        action: null,
        memo_date: null,
        memo_type: null,
    },
    errorMessages: {
        memo: {
            id: [],
            memo_text: [],
            action: [],
            memo_date: [],
            memo_type: [],
        },
    },
    memoOptions: {
        memoTypes: [],
    },
};
const Memos = {
    namespaced: true,
    state: {
        memo: initialMemosState.memo,
        errorMessages: initialMemosState.errorMessages,
        memoOptions: initialMemosState.memoOptions,
    },
    mutations: {
        SET_MEMO_PROPERTY(state, data) {
            _.set(state, data.property, data.value);
            // state.patient[data.property] = data.value;
        },
        RESET_MEMO_PROPERTY_ERROR(state, data) {
            _.set(state.errorMessages, data.property, data.value);
        },
        SET_MEMO(state, data) {
            state.memo = data;
        },
        SET_ERROR_MESSAGE(state, data) {
            _.set(state.errorMessages, data.property, data.value);
            // state.errorMessages[data.property] = data.value;
            // _.set(state, data.property, data.value);
        },
        RESET_MEMO_FORM(state) {
            state.memo = {
                id: null,
                memo_text: null,
                action: null,
                memo_date: null,
                memo_type: null,
            };
        },
        RESET_ERROR_MESSAGES(state) {
            state.errorMessages = {
                memo: {
                    id: null,
                    memo_text: null,
                    action: null,
                    memo_date: null,
                    memo_type: null,
                },
            };
        },
        SET_MEMO_TYPES_OPTIONS(state, options) {
            _.set(state, 'memoOptions.memoTypes', options);
        },
    },
    actions: {
        updateProperty({ commit }, data) {
            commit('SET_MEMO_PROPERTY', data);
        },
        resetAdverseEvent({ commit }) {
            const event = _.clone(initialMemosState.memo);
            _.set(event, 'id', null);
            commit('SET_MEMO', event);
        },
        loadMemo({ commit, dispatch }, data) {
            dispatch('resetErrorMessages');
            return axios
                .get(
                    route('api.v1.patients.memos.show', {
                        patient: data.patient.id,
                        memo: data.id,
                        fields: '*',
                    })
                )
                .then((response) => {
                    const data = _.clone(response.data.data);
                    if (data) {
                        const event = _.clone(data);
                        if (!event.id) {
                            _.set(event, 'id', 'new');
                        }
                        commit('SET_MEMO', event);
                    }
                });
        },
        newMemo({ commit }) {
            commit('SET_MEMO', {
                id: null,
            });
            _.delay(() => {
                const event = _.clone(initialMemosState.memo);
                _.set(event, 'id', 'new');
                commit('SET_MEMO', event);
            }, 300);
        },
        loadMemoOptions({ commit }) {
            return axios
                .get(
                    route('api.v1.memos.config', {
                        sort: 'text',
                    })
                )
                .then((response) => {
                    const data = response.data.data;
                    commit('SET_MEMO_TYPES_OPTIONS', data);
                });
        },
        resetPropertyError({ commit }, data) {
            commit('RESET_MEMO_PROPERTY_ERROR', data);
        },
        setUpdatedProps({ commit }, props) {
            commit('SET_UPDATED_PROPS', props);
        },
        resetForm({ commit }) {
            commit('RESET_MEMO_FORM');
        },
        resetErrorMessages({ commit }) {
            commit('RESET_ERROR_MESSAGES');
        },
        setErrorMessages({ commit, state }, errors) {
            _.each(errors, function (fieldErrors) {
                const errorMessageField = _.get(state.errorMessages.memo, fieldErrors.field);
                if (fieldErrors.field && errorMessageField !== undefined) {
                    commit('SET_ERROR_MESSAGE', {
                        value: fieldErrors.errors,
                        property: 'memo.' + fieldErrors.field,
                    });
                }
            });
        },
    },
};
export default Memos;
